import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal bg-white fade",
  id: "kt_mega_menu_modal",
  "data-bs-backdrop": "false",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "megaMenuRef"
}
const _hoisted_2 = { class: "modal-dialog modal-fullscreen" }
const _hoisted_3 = { class: "modal-content shadow-none" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "modal-header d-flex align-items-center justify-content-between border-0" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "btn btn-icon btn-light-primary ms-2",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/media/icons/duotone/Navigation/Close.svg",
      alt: "Закрыть"
    })
  ])
], -1)
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "row g-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTBrand = _resolveComponent("KTBrand")!
  const _component_KTMenu = _resolveComponent("KTMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_KTBrand)
            ]),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_KTMenu)
            ])
          ])
        ])
      ])
    ])
  ], 512))
}